/**
 * Premium placeholder for cards with status === 'BURNED'.
 * Renders a dark, branded visual instead of attempting to load the original image.
 * Adapts to whatever container size it is placed in via w-full / h-full.
 */
export default function BurnedCardPlaceholder({ cardName, className = '' }) {
  return (
    <div
      className={`relative w-full h-full flex flex-col items-center justify-center overflow-hidden select-none ${className}`}
      style={{
        background: 'linear-gradient(160deg, #1a1025 0%, #0d0a14 45%, #120e1c 100%)',
      }}
    >
      {/* Subtle radial glow */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'radial-gradient(ellipse 70% 50% at 50% 40%, rgba(139,92,246,0.10) 0%, transparent 70%)',
        }}
      />

      {/* Decorative border lines */}
      <div className="absolute inset-2 rounded-lg border border-white/[0.04] pointer-events-none" />

      {/* Flame icon */}
      <div className="relative z-10 flex flex-col items-center gap-1.5">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          className="w-6 h-6 sm:w-8 sm:h-8 text-violet-400/60"
          aria-hidden="true"
        >
          <path
            d="M12 2c.4 3.5 4 6.5 4 10a4 4 0 1 1-8 0c0-3.5 3.6-6.5 4-10Z"
            fill="currentColor"
            fillOpacity="0.25"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinejoin="round"
          />
        </svg>

        {/* Badge */}
        <span className="px-2 py-0.5 rounded text-[8px] sm:text-[9px] font-bold uppercase tracking-widest text-violet-300/80 border border-violet-500/25 bg-violet-500/10">
          Burned
        </span>
      </div>

      {/* Card name (truncated) */}
      {cardName && (
        <p className="relative z-10 mt-2 px-2 text-center text-[9px] sm:text-[10px] leading-snug text-white/30 line-clamp-2 max-w-[90%]">
          {cardName}
        </p>
      )}
    </div>
  )
}
